import React from "react";
import normalizeApiError from "../../utils/normalizeApiError";

export default function ErrorState({
  error,
  message,
  code,
  onRetry,
  hint = "Please try again or contact support if the issue persists.",
  testId = "error-state",
}) {
  const normalized = normalizeApiError(
    error || (message || code ? { message, code } : null)
  );
  const tone = normalized.severity || "error";
  const icon = tone === "warning" ? "⚠️" : tone === "info" ? "ℹ️" : "⛔";
  const titleTone =
    tone === "warning"
      ? "text-amber-700"
      : tone === "info"
      ? "text-sky-700"
      : "text-rose-600";
  return (
    <div className="card p-5 text-center" data-testid={testId}>
      <div className="text-2xl" aria-hidden="true">
        {icon}
      </div>
      <h3 className={`mt-3 text-base font-semibold ${titleTone}`}>
        {normalized.title}
      </h3>
      <p className="mt-2 text-sm text-slate-600">{normalized.message}</p>
      {normalized.code && (
        <p className="mt-2 text-xs uppercase tracking-wide text-slate-400">
          {normalized.code}
        </p>
      )}
      <p className="mt-2 text-xs text-slate-600">{hint}</p>
      {onRetry && (
        <button className="btn btn-secondary mt-4" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
}
